<div *ngIf="!isShowRightMenu" class="us-right-empty">{{TV.TV_SETTING_EMPTY}}</div>
<div *ngIf="isShowRightMenu">
    <!-- Cụm CheckSheet 1-1 và Checksheet(Functional trainning) 2-1 -->
    <div *ngIf="midMenuId == UserSettingMenu.TV_CHECKSHEET_DISPLAY_SETTING">
        <ng-container *ngIf="this.isNyuSho">
            <caremoni-us-menu-right-cs-nyusho
                [displayGroups]="displayGroups"
                [groupSelected]="groupSelected"
                [displayUnits]="displayUnits"
                [unitSelected]="unitSelected"
                [isSortByRoom]="isSortByRoom"
                [isSortByName]="isSortByName"
                [timeRangeSelected]="timeRangeSelected"
                [marginToTimeSelected]="marginToTimeSelected"
                (onChangeUnitHandle)="onChangeUnit($event)" 
                (onChangeGroupHandle)="onChangeGroup($event)" 
                (onChangeTimeRangeHandle)="onChangeTimeRange($event)" 
                (onChangeMarginToTimesHandle)="onChangeMarginToTimes($event)" 
                (onNyuShoRadioClickHandle)="onNyuShoRadioClick($event)" 
            ></caremoni-us-menu-right-cs-nyusho>
        </ng-container>
        <ng-container *ngIf="!this.isNyuSho">
            <caremoni-us-menu-right-cs-tsusho
                [displayGroups]="displayGroups"
                [groupSelected]="groupSelected"
                [displayUnits]="displayUnits"
                [unitSelected]="unitSelected"
                [hiddenOverTime]="this.settingCShDialog.sortConfig.hidden_overtime_flg"
                [hiddenLeaveUser]="this.settingCShDialog.sortConfig.hidden_leave_user"
                [isShortTimeSettingMenu]="isShortTimeSettingMenu"
                [displayOrderSelected]="this.settingCShDialog.sortConfig.display_order"
                (onChangeUnitHandle)="onChangeUnit($event)" 
                (onChangeGroupHandle)="onChangeGroup($event)" 
                (onCheckboxClickHandle)="onCheckboxClick($event)" 
                (onDisplayOrderClickHandle)="onShortTimeDisplayOrderClick($event)"
            >
            </caremoni-us-menu-right-cs-tsusho>
        </ng-container>

    </div>
    <!-- Cụm CheckSheet 1-2 và Checksheet(Functional trainning) 2-2 -->
    <div *ngIf="midMenuId == UserSettingMenu.TV_CHECKSHEET_COLUMN_SETTING">
        <caremoni-us-menu-right-cs-column
            [currentHeaders]="currentHeaders"
            (onChangeHeaderColumnsHandle)="onChangeHeaderColumns($event)"
        ></caremoni-us-menu-right-cs-column>
    </div>
    <!-- Cụm CheckSheet 1-3 và Checksheet(Functional trainning) 2-3 -->
    <div *ngIf="midMenuId == UserSettingMenu.TV_CHECKSHEET_CHANGE_PAGE_SETTING">
        <caremoni-us-menu-right-cs-config
            [timeChangePage]="timeChangePage"
            [isFlashingMoshiokuri]="isFlashingMoshiokuri"
            [marqueeSpeedOptions]="marqueeSpeedOptions"
            [marqueeSpeedRate]="marqueeSpeedRate"
            (onChangeSettingTimeHandle)="onChangeSettingTime($event)"
            (onChangeFlashingTypeHandle)="onChangeFlashingType()"
            (onChangeMarqueeSpeedHandle)="onChangeMarqueeSpeed($event)"
        ></caremoni-us-menu-right-cs-config>
    </div>
    <!-- Cụm Bài Tiết 3-1 -->
    <div *ngIf="midMenuId == UserSettingMenu.TV_EXCREATION_DISPLAY_SETTING">
        <div class="us-right-row">
            <div class="flex-fill">{{CHECKSHEETSETTINGDIALOG.SORT_ORDER}}</div>
            <div class="us-right-item">
                <div class="d-flex" (click)="onExcreationRadioClick(EXCREATION_SORT_TYPE.BY_EXCREATION_TIME)">
                    <caremoni-radio-button 
                        [isChecked]="this.settingCShDialog.excreationConfig.sortType === EXCREATION_SORT_TYPE.BY_EXCREATION_TIME" 
                        [disabled]="false"
                        [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" 
                        [scaledpad]="1.1" 
                        [xdpad]="0" 
                        [ydpad]="0">
                    </caremoni-radio-button>
                    <label for="rdSortExcreationTime" [ngClass]="{'disabled': false}"
                        class="us-right-item-lable">{{CHECKSHEETSETTINGDIALOG.EXCREATTION_TIME}}</label>
                </div>
                <div class="d-flex" (click)="onExcreationRadioClick(EXCREATION_SORT_TYPE.BY_ROOM)">
                    <caremoni-radio-button 
                        [isChecked]="this.settingCShDialog.excreationConfig.sortType === EXCREATION_SORT_TYPE.BY_ROOM" 
                        [disabled]="false"
                        [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" 
                        [scaledpad]="1.1" 
                        [xdpad]="1" 
                        [ydpad]="0">
                    </caremoni-radio-button>
                    <label for="rdSortRoom" [ngClass]="{'disabled': false}"
                        class="us-right-item-lable">{{CHECKSHEETSETTINGDIALOG.SORT_ROOM_NYUSHO}}</label>
                </div>
                <div class="d-flex" (click)="onExcreationRadioClick(EXCREATION_SORT_TYPE.BY_NAME)">
                    <caremoni-radio-button 
                        [isChecked]="this.settingCShDialog.excreationConfig.sortType === EXCREATION_SORT_TYPE.BY_NAME" 
                        [disabled]="false"
                        [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" 
                        [scaledpad]="1.1" 
                        [xdpad]="2" 
                        [ydpad]="0">
                    </caremoni-radio-button>
                    <label for="rdSortName" [ngClass]="{'disabled': false}"
                        class="us-right-item-lable">{{CHECKSHEETSETTINGDIALOG.SORT_NAME_NYUSHO}}</label>
                </div>
            </div>
        </div>
        <div class="us-right-row">
            <label class="flex-fill">{{CHECKSHEETSETTINGDIALOG.DISPLAY_UNIT_NYUSHO}}</label>
            <div class="us-right-item">
                <caremoni-tv-multiselect [id]="'unit-multi-select'" [options]="displayUnits" [selectedValues]="unitSelected"
                    (valueChange)="onChangeUnit($event)" 
                    [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="0"[ydpad]="1">
                </caremoni-tv-multiselect>
            </div>
        </div>
        <div class="us-right-row">
            <label class="flex-fill">{{CHECKSHEETSETTINGDIALOG.DISPLAY_GROUP_NYUSHO}}</label>
            <div class="us-right-item">
                <caremoni-tv-multiselect [id]="'group-multi-select'" [options]="displayGroups" [selectedValues]="groupSelected" 
                    (valueChange)="onChangeGroup($event)"
                    [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1"[xdpad]="0" [ydpad]="2">
                </caremoni-tv-multiselect>       
            </div>
        </div>
    </div>
    <!-- Cụm Bài Tiết 3-2 -->
    <div *ngIf="midMenuId == UserSettingMenu.TV_EXCREATION_CHANGE_PAGE_SETTING">
        <div class="us-right-row">
            <label class="flex-fill">{{CHECKSHEETSETTINGDIALOG.TIME_CHANGE_PAGE}}</label>
            <div class="us-right-item us-right-control">
                <caremoni-textbox [canClear]="false"[inputValue]="timeChangePage" [inputParams]="inputParams"
                    (valueChange)="onChangeGroup($event)" (inputValueChange)="onChangeSettingTime($event)"
                    (onKeyDown)="onInputKeyDown($event)"(focusout)="onFocusOutInput($event)"
                    [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1"[xdpad]="0" [ydpad]="0">
                </caremoni-textbox>
                <label class="pl-2 l-h-40">秒</label>
            </div>
        </div>
        <div class="us-right-row">
            <label class="flex-fill">{{CHECKSHEETSETTINGDIALOG.MARQUEE_SPEED}}</label>
            <div class="us-right-item us-right-control">
                <caremoni-tv-select [id]="'marquee-speed-select'" [options]="marqueeSpeedOptions"
                    [selectedValue]="marqueeSpeedRate" (valueChange)="onChangeMarqueeSpeed($event)"
                    [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="0" [ydpad]="1">
                </caremoni-tv-select>
            </div>
        </div>
    </div>
    <!-- Cụm UserDashBoard 4-1 -->
    <div *ngIf="midMenuId == UserSettingMenu.TV_USER_DB_DISPLAY_SETTING">
        <div class="us-right-row">
            <label class="flex-fill">{{USERDASHBOARDDIALOG.TOTAL_DAY}}</label>
            <div class="us-right-item">
                <caremoni-tv-select class="sl-box-us-db-dp" 
                    [id]="'total-day-select'"
                    [options]="userDBSettings.handOverSetting.handOverTotalDayOptions" 
                    [selectedValue]="userDBSettings.handOverSetting.currentConfigValue" 
                    (valueChange)="onSettingViaAlias(0, $event)"
                    [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1"[xdpad]="0" [ydpad]="0"
                >
                </caremoni-tv-select>
                <label class="pl-2 l-h-40">{{USERDASHBOARDDIALOG.DAY}}</label>
            </div>
        </div>
    </div>
    <!-- Cụm UserDashBoard 4-2 -->
    <div *ngIf="midMenuId == UserSettingMenu.TV_USER_DB_SYSTEM_SETTING">
        <div class="us-right-row">
            <label class="flex-fill">{{CHECKSHEETSETTINGDIALOG.HANDOVER_TIME_CHANGE}}</label>
            <div class="us-right-item us-right-control">
                <caremoni-textbox [canClear]="false"
                    [inputValue]="calcIntervalDisplayValue(1)"
                    [inputParams]="inputFieldSettings"
                    (inputValueChange)="onSettingViaAlias(1, $event)"
                    [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="0" [ydpad]="0">
                </caremoni-textbox>
                <label class="pl-2 l-h-40">{{USERDASHBOARDDIALOG.SECOND}}</label>
            </div>
        </div>
        <div class="us-right-row">
            <label class="flex-fill">{{CHECKSHEETSETTINGDIALOG.MARQUEE_SPEED}}</label>
            <div class="us-right-item us-right-control">
                <caremoni-tv-select [id]="'marquee-speed-select'" [options]="marqueeSpeedOptions"
                    [selectedValue]="marqueeSpeedRate" (valueChange)="onChangeMarqueeSpeed($event)"
                    [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="0" [ydpad]="1">
                </caremoni-tv-select>
            </div>
        </div>
        <div class="us-right-row">
            <label class="flex-fill">{{CHECKSHEETSETTINGDIALOG.IMG_SWITCHING_TIME}}</label>
            <div class="us-right-item us-right-control">
                <caremoni-textbox [canClear]="false"
                    [inputValue]="calcIntervalDisplayValue(2)"
                    [inputParams]="inputFieldSettings"
                    (inputValueChange)="onSettingViaAlias(2, $event)"
                    [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1"[xdpad]="0" [ydpad]="2">
                </caremoni-textbox>
                <label class="pl-2 l-h-40">{{USERDASHBOARDDIALOG.SECOND}}</label>
            </div>
        </div>
        <div class="us-right-row">
            <label class="flex-fill">{{CHECKSHEETSETTINGDIALOG.CARE_PLAN_SWUTCHING_TIME}}</label>
            <div class="us-right-item us-right-control">
                <caremoni-textbox [canClear]="false"
                    [inputValue]="calcIntervalDisplayValue(3)"
                    [inputParams]="inputFieldSettings"
                    (inputValueChange)="onSettingViaAlias(3, $event)"
                    [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1"[xdpad]="0" [ydpad]="3">
                </caremoni-textbox>
                <label class="pl-2 l-h-40">{{USERDASHBOARDDIALOG.SECOND}}</label>
            </div>
        </div>
    </div>
    <!-- Cụm Checksheet Tắm 5-1 -->
    <div *ngIf="midMenuId == UserSettingMenu.TV_BATHE_DISPLAY_SETTING">
        <div class="us-right-row">
            <div class="flex-fill">{{CHECKSHEETSETTINGDIALOG.SORT_ORDER}}</div>
            <div class="us-right-item">
                <div *ngIf="isNyuSho" class="d-flex" (click)="bathScreenRadioClick(BATHE_SORT_TYPE.BY_ROOM)">
                    <caremoni-radio-button 
                        [isChecked]="this.settingCShDialog.bathingScreenConfig.sortType === BATHE_SORT_TYPE.BY_ROOM" 
                        [disabled]="false"
                        [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="0" [ydpad]="0">
                    </caremoni-radio-button>
                    <label for="rdSortRoom" [ngClass]="{'disabled': false}" class="us-right-item-lable">{{CHECKSHEETSETTINGDIALOG.SORT_ROOM_NYUSHO}}</label>
                </div>
                <div class="d-flex" 
                    (click)="bathScreenRadioClick(BATHE_SORT_TYPE.BY_NAME)">
                    <caremoni-radio-button 
                        [isChecked]="this.settingCShDialog.bathingScreenConfig.sortType === BATHE_SORT_TYPE.BY_NAME"
                        [disabled]="false"
                        [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="isNyuSho ? 1 : 0" [ydpad]="0">
                    </caremoni-radio-button>
                    <label for="rdSortName" [ngClass]="{'disabled': false}" class="us-right-item-lable">{{CHECKSHEETSETTINGDIALOG.SORT_NAME_NYUSHO}}</label>
                </div>
                <div class="d-flex" 
                    (click)="bathScreenRadioClick(BATHE_SORT_TYPE.BY_BATH_ORDER)">
                    <caremoni-radio-button [isChecked]="this.settingCShDialog.bathingScreenConfig.sortType === BATHE_SORT_TYPE.BY_BATH_ORDER"
                        [disabled]="false"
                        [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="isNyuSho ? 2 : 1" [ydpad]="0">
                    </caremoni-radio-button>
                    <label for="rdSortName" [ngClass]="{'disabled': false}" class="us-right-item-lable">{{BATHINGDIALOG.SORT_BATH_ROOM}}</label>
                </div>
            </div>
        </div>
        <div class="us-right-row">
            <label class="flex-fill">{{CHECKSHEETSETTINGDIALOG.DISPLAY_UNIT_NYUSHO}}</label>
            <div class="us-right-item">
                <caremoni-tv-multiselect [id]="'unit-multi-select'" [options]="displayUnits" [selectedValues]="unitSelected"
                    (valueChange)="onChangeUnit($event)" 
                    [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="0"[ydpad]="1">
                </caremoni-tv-multiselect>
            </div>
        </div>
        <div class="us-right-row">
            <label class="flex-fill">{{CHECKSHEETSETTINGDIALOG.DISPLAY_GROUP_NYUSHO}}</label>
            <div class="us-right-item">
                <caremoni-tv-multiselect [id]="'group-multi-select'"  [options]="displayGroups" [selectedValues]="groupSelected" 
                    (valueChange)="onChangeGroup($event)"
                    [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1"[xdpad]="0" [ydpad]="2">
                </caremoni-tv-multiselect>       
            </div>
        </div>
        <div class="us-right-row">
            <label class="flex-fill">{{BATHINGDIALOG.BATH_ROOM_FILTERING_LBL}}</label>
            <div class="us-right-item">
                <caremoni-tv-select 
                    class="select-box-custom"
                    [id]="'bath-room-select'"
                    [options]="displayBathRooms" 
                    [selectedValue]="bathRoomSelected"
                    (valueChange)="onChangeBathRoom($event)"
                    [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="0" [ydpad]="3"> 
                </caremoni-tv-select>       
            </div>
        </div>
    </div>
    <!-- Cụm Checksheet Tắm  5-2 -->
    <div *ngIf="midMenuId == UserSettingMenu.TV_BATHE_COLUMN_SETTING">
        <caremoni-us-menu-right-cs-column
            [currentHeaders]="currentBathHeaders"
            (onChangeHeaderColumnsHandle)="onChangeBatheHeaderColumns($event)"
        ></caremoni-us-menu-right-cs-column>
    </div>
    <!-- Cụm Checksheet Tắm 5-3 -->
    <div *ngIf="midMenuId == UserSettingMenu.TV_BATHE_CHANGE_PAGE_SETTING">
        <caremoni-us-menu-right-cs-config
            [timeChangePage]="timeChangePage"
            [isShowFlashing] = "false"
            [isFlashingMoshiokuri]="isFlashingMoshiokuri"
            [marqueeSpeedOptions]="marqueeSpeedOptions"
            [marqueeSpeedRate]="marqueeSpeedRate"
            (onChangeSettingTimeHandle)="onChangeSettingTime($event)"
            (onChangeFlashingTypeHandle)="onChangeFlashingType()"
            (onChangeMarqueeSpeedHandle)="onChangeMarqueeSpeed($event)"
        ></caremoni-us-menu-right-cs-config>
    </div>
    <!-- Cụm DeviceName 6-1 -->
    <div *ngIf="midMenuId == UserSettingMenu.TV_DEVICE_NAME_SETTING">
        <div class="us-right-row">
            <label class="flex-fill">{{TV.TV_DEVICE_NAME}}</label>
            <div class="us-right-item">
                <caremoni-textbox class="us-right-device-name" [inputId]="DEVICE_NAME_INPUT_ID" [canClear]="false" [inputValue]="deviceName" [inputParams]="deviceNameInputParams"
                    (inputValueChange)="onChangeDeviceName($event)" (onKeyboardDone)="onDeviceNameKeyboardDone($event)"
                    (onFocusOut)="onDeviceNameFocusOut()"
                    [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="0" [ydpad]="0">
                </caremoni-textbox>
            </div>
        </div>
        <div class="us-right-row">
            <label class="flex-fill">{{TV.TV_APP_VERSION}}</label>
            <div class="us-right-item">
                <label class="us-right-item-lable">{{appVersion}}</label>
            </div>
        </div>
        <div class="us-right-row">
            <label class="flex-fill">{{TV.TV_WEBVIEW_VERSION}}</label>
            <div class="us-right-item">
                <label class="us-right-item-lable">{{webViewVersion}}</label>
            </div>
        </div>
        <div class="us-right-row us-right-login-office">
            <label class="flex-fill">{{TV.TV_LOGIN_OFFICE}}</label>
            <div class="us-right-item">
                <label class="us-right-item-lable">{{loginOfficeName}}</label>
            </div>
        </div>
        <div class="us-right-row">
            <label class="flex-fill">{{TV.TV_LOGIN_USER}}</label>
            <div class="us-right-item">
                <label class="us-right-item-lable">{{loginStaffName}}</label>
            </div>
        </div>
        <div *ngIf="lastLoginDate" class="us-right-row">
            <label class="flex-fill">{{TV.TV_LAST_LOGIN_DATE}}</label>
            <div class="us-right-item">
                <label class="us-right-item-lable">{{lastLoginDate}}</label>
            </div>
        </div>
        <div class="us-right-row us-right-device-buttons">
            <caremoni-button [buttonType]="ButtonType.SECONDARY" [buttonText]="TV.TV_RESET_WEB"
                [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="0" [ydpad]="1"
                (btnClick)="onReloadWebClick()">
            </caremoni-button>
        </div>
    </div>
</div>
